import React, { useState } from 'react'
import DeleteModal from '../../../../Components/modals/DeleteModal'
import { toastMessage } from '../../../../utils/toastMessage';
import { exitGroupApi } from '../../../../services/groups';

const ExitGroup = ({
    show,
    close,
    groupId,
    memberId,
    groupName = 'this group',
    type,
    detailAPi = () => { },
    memberApi = () => { }
}) => {
    const [loading, setLoading] = useState(false)

    //-----------exit-group--------------
    const exitGroup = async () => {
        try {
            setLoading(true);
            let payLoad = {}
            if (type === "SELF") {
                payLoad._group = groupId;
                payLoad.type = "SELF";
            } else {
                payLoad._group = groupId;
                payLoad.type = "MEMBER";
                payLoad._user = memberId;
            }
            const { data } = await exitGroupApi(payLoad);
            const { success, message } = data;
            if (success) {
                toastMessage(message, "success", "exitGroup");
                close();
                detailAPi()
                if (memberApi) {
                    memberApi()
                }
            }
        } catch (e) {
            console.log("Error=-", e.message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <DeleteModal
            show={show}
            handleClose={close}
            deleteAccountHandler={exitGroup}
            loading={loading}
            text={<span>Are you sure you want to Exit from <b>{groupName}</b>?</span>}

        />
    )
}

export default ExitGroup